import React from 'react';
import { classes } from './Field.classes';
import { FieldProps } from './Field.types';
import { dataHooks } from '../../constants';

const Field = ({
  noPadding = false,
  divider = 'auto',
  dataHook,
  children,
}: FieldProps) => {
  return (
    <div
      className={classes.root({
        padded: !noPadding,
        divider: String(divider) as 'auto' | 'true' | 'false',
      })}
      data-hook={dataHook || dataHooks.sidePanelField}
      data-hoverable-action-trigger
    >
      {children}
    </div>
  );
};

Field.displayName = 'Field';

export { Field };
